import { useIntl } from '@capsicum/common';
import { GenericDrawer, useGoatImage } from '@capsicum/common-web';

export type PaymentRejectDrawerProps = {
	closeModal: () => void;
	testID: string;
};

export const PaymentRejectDrawer = ({ closeModal, testID }: PaymentRejectDrawerProps) => {
	const { $t } = useIntl();
	const goatAnkwardImage = useGoatImage('ankward');

	const paymentRejectDrawerData = {
		buttonText: $t('wallet.partnerDetails.marketplace.paymentRejectDrawer.buttonText'),
		description: $t('wallet.partnerDetails.marketplace.paymentRejectDrawer.restrictedInGeoArea.description'),
		image: goatAnkwardImage,
		testID: testID,
		title: $t('wallet.partnerDetails.marketplace.paymentRejectDrawer.restrictedInGeoArea.title')
	};

	return <GenericDrawer {...paymentRejectDrawerData} onButtonPress={closeModal}></GenericDrawer>;
};
